const products = {
  title: 'Productos',
  lead: 'Siete grados de canela de Ceilán, además de aceite de canela, pimienta y nuez de areca. Marque lo que le interesa y solicite una sola cotización para todo.',
  guidePrompt: '¿No sabe qué grado le conviene?',
  guideLink: 'Consulte la guía de grados →',
  samplesPrompt: '¿Quiere comprobar la calidad primero?',
  samplesLink: 'Solicite muestras →',

  tableCaption: 'Grados y especificaciones de la canela de Ceilán',
  columns: { grade: 'Grado', diameter: 'Diámetro', colour: 'Color', bestFor: 'Ideal para', packing: 'Empaque', add: 'Agregar a la cotización' },
  onRequest: 'A solicitud',

  groups: [
    {
      title: 'Rama Continental',
      note: 'Los grados más delgados y claros. Se clasifican por el diámetro de la rama.',
      items: [
        { id: 'c5', name: 'C5', diameter: '10–12 mm', colour: 'Amarillo canela', bestFor: 'Rama para menudeo, regalos, cafeterías', packing: 'Según sus especificaciones' },
        { id: 'c4', name: 'C4', diameter: '13–16 mm', colour: 'Dorado / amarillo claro', bestFor: 'Rama para menudeo, té y café', packing: 'Según sus especificaciones' },
      ],
    },
    {
      title: 'Rama Hamburgo',
      note: 'Ramas más anchas y gruesas. Normalmente se muelen.',
      items: [
        { id: 'h1', name: 'H1', diameter: '25–27 mm', colour: 'Dorado oscuro', bestFor: 'Molienda, panadería, mezclas de especias', packing: 'Según sus especificaciones' },
        { id: 'h2', name: 'H2', diameter: '28–32 mm', colour: 'Dorado oscuro', bestFor: 'Molienda, panadería, mezclas de especias', packing: 'Según sus especificaciones' },
        { id: 'h3', name: 'H3', diameter: 'A solicitud', colour: 'A solicitud', bestFor: 'Molienda e industria', packing: 'Según sus especificaciones' },
      ],
    },
    {
      title: 'Trozos',
      note: 'La misma corteza en formas irregulares. Se vende por peso.',
      items: [
        { id: 'quillings', name: 'Quillings', diameter: 'Trozos de rama', colour: 'Mixto', bestFor: 'Molienda, infusiones, mezclas', packing: 'Bolsas de plástico' },
        { id: 'offcuts', name: 'Recortes', diameter: 'Puntas de rama recortadas', colour: 'Mixto', bestFor: 'Molienda industrial y extracción', packing: 'Cajas de 5 o 10 kg' },
      ],
    },
  ],

  othersTitle: 'Otros productos',
  others: [
    { id: 'oil', name: 'Aceite de canela', detail: 'De hoja y de corteza' },
    { id: 'pepper', name: 'Pimienta', detail: 'Pimienta negra en grano' },
    { id: 'arecanut', name: 'Nuez de areca', detail: 'Areca (betel) seca' },
  ],

  galleryTitle: 'De nuestro inventario',
  terms: ['Clasificada según SLS 81', 'Muestras disponibles', 'Pago antes de la producción', 'EXW, FOB, CFR, CIF o DAP', 'Marca propia disponible'],
  termsLink: 'Cómo funcionan los pedidos →',

  add: 'Agregar',
  added: 'Agregado',
  addLabel: (name) => `Agregar ${name} a la cotización`,
  removeLabel: (name) => `Quitar ${name} de la cotización`,
  photoLabel: (name) => `Foto de ${name}`,
  previewLabel: (name) => `Foto de ${name}`,
  close: 'Cerrar',
  selectedCount: (n) => (n === 1 ? '1 seleccionado' : `${n} seleccionados`),
  clear: 'Borrar',
  requestQuote: 'Solicitar cotización',
  requestSamples: 'Muestras',
};

export default products;
